export default "__VITE_ASSET__xbKmVVMd__"